<!-- Login / registration half page -->
<div class="flex flex-col justify-center align-center gap-4 sm:gap-5 md:gap-6 w-full">
  <div class="flex flex-col justify-start align-center w-full gap-1.5 sm:gap-2">
    <h2 class="text-(--bordeaux-1400) text-lg sm:text-xl md:text-3xl font-semibold leading-tight sm:leading-8">
      {{ title() }}
    </h2>

    <p class="text-black text-sm font-normal leading-5">
      {{
      title() === "Accedi"
      ? "Inserisci qui sotto email e password per accedere"
      : "Ti chiediamo un ultimo sforzo aggiungendo i tuoi dati personali"
      }}
    </p>
  </div>

  <div class="w-full flex justify-center">
    <hlm-tabs [tab]="activeTab()" class="w-full flex flex-col justify-center align-center">
      <!-- <hlm-tabs-list class="w-full grid grid-cols-2 bg-(--sabbia-300)" aria-label="tabs example">
        <button hlmTabsTrigger="login" (click)="onTabChange(AuthTab.LOGIN)">
          {{ AUTH_TAB_LABELS[AuthTab.LOGIN] }}
        </button>
        <button hlmTabsTrigger="registration" (click)="onTabChange(AuthTab.REGISTER)">
          {{ AUTH_TAB_LABELS[AuthTab.REGISTER] }}
        </button>
      </hlm-tabs-list> -->
      <form hlmTabsContent="login" [formGroup]="form" (ngSubmit)="submit('signin')">
        <section class="flex flex-col gap-6 !border-none !shadow-none !bg-transparent" hlmCard>
          <div class="px-0 py-0 pt-5 flex flex-col gap-6 !bg-transparent" hlmCardContent>
            <label class="block" hlmLabel>
              Email
              <hlm-form-field>
                <input formControlName="email" class="mt-1.5 w-full" placeholder="Inserisci email" hlmInput />
                <hlm-error>L'email è obbligatoria e deve essere una email
                  valida.</hlm-error>
              </hlm-form-field>
            </label>
            <label class="block" hlmLabel>
              <div class="flex justify-between items-center">
                Password
                <button hlmBtn variant="link" class="w-full flex justify-end p-0 h-auto font-thin"
                  (click)="onResetPasswordClick()" type="button" tabindex="-1">
                  Password dimenticata?
                </button>
              </div>
              <hlm-form-field>
                <div class="relative">
                  <input formControlName="password" class="mt-1.5 w-full pr-10" [type]="showLoginPassword() ? 'text' : 'password'"
                    placeholder="Inserisci password" hlmInput />
                  <button
                    type="button"
                    (click)="toggleLoginPasswordVisibility()"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-(--muted-foreground) hover:text-(--foreground) transition-colors"
                    tabindex="-1"
                  >
                    <ng-icon hlm size="sm" [name]="showLoginPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                  </button>
                </div>
                <hlm-error>La password è obbligatoria.</hlm-error>
              </hlm-form-field>
            </label>
          </div>
          <div class="p-0 pt-0" hlmCardFooter>
            <div class="w-full flex flex-col gap-6">
              <button [disabled]="isDisabled()" class="w-full" hlmBtn>
                @if (isLoading()) {
                <hlm-spinner />
                } @else {
                Accedi
                }
              </button>

              <div class="flex justify-center items-center">
                <div class="h-0.25 flex-1 bg-(--base-border)"></div>
                <p class="text-(--card-bg-2) text-xs pl-0.5 pr-0.5 font-light">Accesso professionisti</p>
                <div class="h-0.25 flex-1 bg-(--base-border)"></div>
              </div>

              <keus-ui-google-button (clickEvent)="submit('google')"></keus-ui-google-button>
            </div>
          </div>
        </section>
      </form>

      <form hlmTabsContent="registration" [formGroup]="form" (ngSubmit)="submit('signup')">
        <section class="flex flex-col gap-6 !border-none !shadow-none !bg-transparent" hlmCard>
          <div class="px-0 py-0 pt-5 flex flex-col gap-6 !bg-transparent" hlmCardContent>
            <label class="block" hlmLabel>
              Email*
              <hlm-form-field>
                <input formControlName="email" class="mt-1.5 w-full" placeholder="Inserisci email" hlmInput />
                <hlm-error>L'email è obbligatoria e deve essere una email
                  valida.</hlm-error>
              </hlm-form-field>
            </label>
            <label class="block" hlmLabel>
              Password*
              <hlm-form-field>
                <div class="relative">
                  <input formControlName="password" class="mt-1.5 w-full pr-10" [type]="showRegistrationPassword() ? 'text' : 'password'"
                    placeholder="Inserisci password" hlmInput />
                  <button
                    type="button"
                    (click)="toggleRegistrationPasswordVisibility()"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-(--muted-foreground) hover:text-(--foreground) transition-colors"
                    tabindex="-1"
                  >
                    <ng-icon hlm size="sm" [name]="showRegistrationPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                  </button>
                </div>
                <hlm-error>La password è obbligatoria.</hlm-error>

                <keus-password-requirements [control]="form.controls.password"></keus-password-requirements>
              </hlm-form-field>
            </label>
            <label class="block" hlmLabel>
              Conferma Password*
              <hlm-form-field>
                <div class="relative">
                  <input formControlName="confirmPassword" class="mt-1.5 w-full pr-10" [type]="showConfirmPassword() ? 'text' : 'password'"
                    placeholder="Conferma password" hlmInput />
                  <button
                    type="button"
                    (click)="toggleConfirmPasswordVisibility()"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-(--muted-foreground) hover:text-(--foreground) transition-colors"
                    tabindex="-1"
                  >
                    <ng-icon hlm size="sm" [name]="showConfirmPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                  </button>
                </div>
                <hlm-error>È obbligatoria e deve essere uguale alla password.</hlm-error>
              </hlm-form-field>
            </label>

            <!-- Privacy Policy Checkbox (Mandatory) -->
            <div class="flex items-start gap-3">
              <hlm-checkbox
                formControlName="privacyAccepted"
                id="privacy-accepted"
                class="mt-0.5 h-4 w-4"
              />
              <label for="privacy-accepted" class="text-sm leading-5 cursor-pointer">
                Ho letto e compreso l'<a
                  href="https://checksmate.chino.io/company/426/policies/external/adeedcdd-bbe4-400f-a171-c86676a3686f?as=html"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-(--bordeaux-1400) underline hover:text-(--bordeaux-1200)"
                >Informativa sulla Privacy</a> della piattaforma Talea*
              </label>
            </div>

            <!-- Marketing Consent Checkbox (Optional) -->
            <div class="flex items-start gap-3">
              <hlm-checkbox
                formControlName="marketingConsent"
                id="marketing-consent"
                class="mt-0.5 h-4 w-4"
              />
              <label for="marketing-consent" class="text-sm leading-5 cursor-pointer">
                Presto il consenso alla ricezione tramite e-mail ed sms di promemoria delle prenotazioni sulla piattaforma e di comunicazioni informative su novità ed eventi promossi e/o organizzati da Talea in merito alla cura della fertilità e PMA.
              </label>
            </div>
          </div>
          <div class="p-0 pt-0" hlmCardFooter>
            <div class="w-full flex flex-col gap-6">
              <button [disabled]="isDisabled()" class="w-full" hlmBtn>
                @if (isLoading()) {
                <hlm-spinner />
                } @else {
                Scopri il tuo medico
                }
              </button>

              <!-- <div>
                <img src="or-separator.svg" alt="separator" class="w-full" />
              </div> -->

              <!-- <keus-ui-google-button
                (clickEvent)="submit('google')"
              ></keus-ui-google-button> -->
            </div>
          </div>
        </section>
      </form>

      <div hlmTabsContent="google">
        <keus-ui-google-button (clickEvent)="submit('google')"></keus-ui-google-button>
      </div>
    </hlm-tabs>
  </div>
</div>